export default Object.freeze({
  INVOICE_ALREADY_GENERATED: 'INVOICE_ALREADY_GENERATED',
  INVOICE_ALREADY_REQUESTED: 'INVOICE_ALREADY_REQUESTED',
  INVOICE_TOO_OLD: 'INVOICE_TOO_OLD',
  MISSING_NUMBER_OR_TOTAL: 'MISSING_NUMBER_OR_TOTAL',
  NOT_FOUND: 'NOT_FOUND',
  NUMBER_IS_NAN: 'NUMBER_IS_NAN',
  UNAUTHORIZED: 'UNAUTHORIZED',
});
